export type MatchMode = 'time_attack' | 'under_clicks';
export type Difficulty = 'easy' | 'normal' | 'hard' | 'insane';
export type ChallengeStatus = 'pending' | 'accepted' | 'completed' | 'declined' | 'expired';
export type LeagueRole = 'owner' | 'mod' | 'member';
export type SeasonStatus = 'scheduled' | 'active' | 'ended';

export interface Match {
  id: string;
  lang_code: string;
  start_title: string;
  target_title: string;
  mode: MatchMode;
  difficulty: Difficulty;
  seed: string;
  is_daily: boolean;
  created_by: string | null;
  created_at: string;
}

export interface Run {
  id: string;
  user_id: string | null;
  match_id: string;
  started_at: string;
  ended_at: string | null;
  duration_ms: number | null;
  clicks: number;
  completed: boolean;
  is_public: boolean;
  path: string[];
  created_at: string;
  match?: Match;
  profile?: Profile;
}

export interface Profile {
  id: string;
  username: string;
  display_name: string | null;
  avatar_url: string | null;
  is_public: boolean;
  is_verified: boolean;
  created_at: string;
  updated_at: string;
}

export interface Entitlement {
  user_id: string;
  remove_ads: boolean;
  source: 'purchase' | 'verified' | 'admin_grant' | null;
  created_at: string;
  updated_at: string;
}

export interface League {
  id: string;
  owner_user_id: string;
  name: string;
  description: string | null;
  is_public: boolean;
  join_code: string | null;
  created_at: string;
  owner?: Profile;
  member_count?: number;
}

export interface LeagueMember {
  league_id: string;
  user_id: string;
  role: LeagueRole;
  joined_at: string;
  profile?: Profile;
}

export interface LeagueSeason {
  id: string;
  league_id: string;
  starts_at: string;
  ends_at: string;
  status: SeasonStatus;
}

export interface LeagueRound {
  id: string;
  season_id: string;
  round_number: number;
  match_id: string;
  starts_at: string;
  ends_at: string;
  match?: Match;
}

export interface LeagueScore {
  round_id: string;
  user_id: string;
  best_run_id: string | null;
  points: number;
  profile?: Profile;
  run?: Run;
}

export interface Challenge {
  id: string;
  from_user_id: string;
  to_user_id: string | null;
  match_id: string;
  target_run_id: string | null;
  status: ChallengeStatus;
  created_at: string;
  from_user?: Profile;
  match?: Match;
  target_run?: Run;
}

export interface GameState {
  match: Match | null;
  currentArticle: string;
  path: string[];
  clicks: number;
  startTime: number | null;
  isPlaying: boolean;
  isCompleted: boolean;
  isFailed: boolean;
}

export interface WikiArticle {
  title: string;
  html: string;
  extract?: string;
}

export const CLICK_LIMITS: Record<Difficulty, number> = {
  easy: 15,
  normal: 10,
  hard: 7,
  insane: 5,
};

export const DIFFICULTY_LABELS: Record<Difficulty, string> = {
  easy: 'Easy',
  normal: 'Normal',
  hard: 'Hard',
  insane: 'Insane',
};

export const MODE_LABELS: Record<MatchMode, string> = {
  time_attack: 'Time Attack',
  under_clicks: 'Under N Clicks',
};
